// Categories live in the DB and are managed by an admin — fetch them with
// `useCategories()` instead of hardcoding a list here.

// Public site origin. In production the dashboard is served from the same host
// under /dashboard, so the origin is already right; REACT_APP_SITE_URL exists to
// override it in local dev, where the site runs on a different port.
export const SITE_URL = (
  process.env.REACT_APP_SITE_URL ||
  (typeof window !== "undefined" ? window.location.origin : "")
).replace(/\/+$/, "");

export const blogPostUrl = (slug) => (slug ? `${SITE_URL}/blog/${slug}` : "");

export const STATUS_META = {
  published: { label: "Published", color: "#1E7F4F", bg: "#E5F4EC" },
  pending: { label: "Pending", color: "#B26A00", bg: "#FBF0DD" },
  draft: { label: "Draft", color: "#576874", bg: "#EDF0F2" },
  rejected: { label: "Rejected", color: "#B23A48", bg: "#FBE5E8" },
};
